<template>
  <div class="vcl-totp">
    <vp-icon icon="close" class="vcl-logon__close-button" @click="close" />
    <h3 class="vcl-logon__title">{{ $t('twoFactorAuth') }}</h3>
    <p class="vcl-logon__description">{{ $t('verifyIdentityMessage') }}</p>
    <vp-input
      v-model="totp"
      autofocus
      width="100%"
      height="50px"
      :placeholder="$t('enterCode')"
      type="text"
      required
      :styles="inputStyles"
    >
      <template #error>
        {{ error }}
      </template>
    </vp-input>
    <vp-button
      class="vcl-logon__button primary large"
      :disabled="!totp"
      :styles="buttonStyles"
      @click="login"
    >
      {{ $t('verify') }}
    </vp-button>
  </div>
</template>

<script>
// General Components
import VpIcon from '../../components/vp-icon/VpIcon.vue';
import VpInput from '../../components/vp-input/VpInput.vue';
import VpButton from '../../components/vp-button/VpButton.vue';

export default {
  name: 'VpTotp',
  components: {
    VpIcon,
    VpInput,
    VpButton,
  },
  inject: ['$busy', '$auth'],
  props: {
    styles: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      totp: null,
      error: null,
    };
  },
  computed: {
    inputStyles() {
      return this.styles.input || {};
    },
    buttonStyles() {
      return this.styles.button || {};
    },
  },
  created() {
    window.addEventListener('keyup', this.keyListener);
  },
  beforeDestroy() {
    window.removeEventListener('keyup', this.keyListener);
  },
  mounted() {
    this.$busy.on(false);
  },
  methods: {
    login() {
      this.$busy.on(true);
      const { logon } = this.$deps;

      const { token, uid, usingPassword = false, usingSaml = false } = this.$route.query;

      return logon.login({ totp: this.totp, uid, token, usingPassword, usingSaml })
        .then((data) => {
          const { loggedIn } = data;
          if (!loggedIn) {
            return this.$router.push({ path: '/logon/error', query: {} });
          }

          this.$auth.set(true);
          return logon.loginRedirect();
        })
        .catch(() => {
          return this.$router.push({ path: '/logon/error', query: {} });
        })
        .finally(() => {
          this.$busy.on(false);
        });
    },
    close() {
      return this.$router.push('/logon');
    },
    keyListener(event) {
      if (event.key === 'Enter' && this.totp) {
        return this.login();
      }

      if (event.key === 'Escape') {
        return this.close();
      }

      return null;
    },
  }
};
</script>

<style lang="scss" scoped>
@import "../../styles/mixins.scss";

.vcl-totp {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0;
  padding: 34px 30px 24px;
  @include Tablet {
    padding: 55px 47px 0px;
    .vcl-logon__description {
      margin-bottom: 37px;
    }
  }
}

div.vcl-input {
  margin-bottom: 180px !important;
}
</style>
